import axios from 'axios'
// const access_token = localStorage.getItem('signature')
const axiosInstance = axios.create({
  baseURL: 'https://wordle.nagorik.tech/api/',
  headers: { Accept: 'application/json', 'Access-Control-Allow-Origin': '*' },
})

export default axiosInstance
